import RarityBadge from './RarityBadge'

export default RarityBadge
